<template>
  <div class="special universal">
    <h1 class="page-title">特训班 · {{date_content.count||0}}</h1>
    <None v-if="date_content.list==null ||date_content.list.length == 0" />
    <div v-else>
      <SpecialContentItem
        v-for="(item,index) in date_content.list"
        :key="item.id"
        :dateObject="item"
        :index="(index + 1 + (pageInfo.current - 1) * pageInfo.pageSize)"
      />
    </div>
    <DevPagination
      class="margin-top-66"
      :total="date_content.count"
      :pageSize="10"
      @currentChange="postDate"
    />
  </div>
</template>

<script>
import DevPagination from "@/components/Base/DevPagination.vue";
import SpecialContentItem from "@/components/Course/SpecialContentItem.vue";
import None from "@/components/Base/None.vue";
import { getTeachVideoList } from "@/utils/api";

export default {
  components: {
    DevPagination,
    SpecialContentItem,
    None,
  },
  data() {
    return {
      date_content: {},
      pageInfo: "",
    };
  },
  methods: {
    postDate(page) {
      this.pageInfo = page;
      this.$store.dispatch("changeLoading", true);
      getTeachVideoList({
        page: page.current,
        pageSize: page.pageSize,
      }).then((response) => {
        this.date_content = response.data.data;
        this.$store.dispatch("changeLoading", false);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.special {
  .margin-top-66 {
    margin-top: 66px;
  }
}
</style>
